<template>
    <st-filters-pagination
        stateModule="documentTemplate/list"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :header="$t('DOCUMENT_TEMPLATE.LIST.TABLE_HEADER')"
        :moreFilters="false"
    >
        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { DocumentTemplateModel } from '@/modules/document-template/document-template-model';

    const { fields } = DocumentTemplateModel;

    const filterSchema = new FilterSchema([
        fields.name,
    ]);

    export default {
        name: 'DocumentTemplateListFilter',
        data() {
            return {
                filters: filterSchema.fields,
                currentPage: 1,
            };
        },
        computed: {
            ...mapGetters({
               total: 'documentTemplate/list/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'documentTemplate/list/doFetch',
            }),
            async doFilter(params) {
                this.doFetch(params);
            },
        },

    };
</script>

<style scoped>

</style>
